import React from "react";
import { NavLink } from "react-router-dom";
import { useAppState } from "../state/AppStateContext";
import { t } from "../i18n/strings";

function NavItem({ to, label, children }) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      style={({ isActive }) => ({
        ...styles.item,
        color: isActive ? "var(--color-accent)" : "#6b7a96",
      })}
    >
      {children}
      <span style={styles.label}>{label}</span>
    </NavLink>
  );
}

export default function BottomNav() {
  const { lang } = useAppState();

  return (
    <div style={styles.wrap}>
      <NavItem to="/" label={t(lang, "navCheck")}>
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7" />
          <path d="M21 21l-4.3-4.3" />
        </svg>
      </NavItem>
      <NavItem to="/history" label={t(lang, "navHistory")}>
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      </NavItem>
      <NavItem to="/profile" label={t(lang, "navProfile")}>
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
        </svg>
      </NavItem>
    </div>
  );
}

const styles = {
  wrap: { display: "flex", background: "var(--panel)", borderTop: "1px solid var(--color-divider)", padding: "10px 6px 14px", flex: "none" },
  item: {
    flex: 1,
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    padding: "6px 0",
    textDecoration: "none",
  },
  label: { fontSize: 11, fontWeight: 600 },
};
